import React from "react"
import Stub from "../Stub"

const ReenvioMasivo = () => (
  <Stub
    title="Reenvío masivo"
    icon="mdi-email-send-outline"
    descripcion="Reenvío de múltiples correos en lote por filtros o selección manual"
    alcance={[
      "Selección de facturas por rango de fechas, estado (failed/bounce) o prefijo",
      "Vista de previsualización antes de disparar el reenvío masivo",
      "Opción de cambiar el destinatario global o por factura",
      "Cola de envío con progreso en tiempo real y resultado por factura",
      "Bitácora exportable a CSV con resultado de cada reenvío",
    ]}
    endpoints={[
      { method: "GET", path: "/a7/inbox?nitemisor=X&estado=failed&limit=...", desc: "Listado de candidatos a reenviar" },
      { method: "POST", path: "/a7/reenviar", desc: "Por cada CUFE seleccionado" },
    ]}
  />
)

export default ReenvioMasivo
